import { formatLotText, formatMeasureValueText } from "@src/components/business-data-display";
import type { StockActInvContent } from "../../../../../api/stockActInvs";
import type { StorePlaceRemainder } from "../../../../../api/storePlaces";

/** Возвращает текст ячеек хранения строки АИ. */
export function formatInventoryCells(remainders?: StorePlaceRemainder[]): string {
    if (remainders == null || remainders.length === 0) {
        return "Не задано";
    }

    return remainders.map((item) => item.StorePlace?.Num ?? `Ячейка ${item.SpCode}`).join(", ");
}

/**
 * Признак партийной строки АИ (`ParentLotCode !== 0`). \
 * Для Freor ТСД безпартийные строки показываем в списке disabled; сценарий инвентаризации пока не поддерживается.
 * @param content строка состава АИ
 */
export function isStockFullInventoryContentLotBased(content: Pick<StockActInvContent, "ParentLotCode">): boolean {
    return content.ParentLotCode !== 0;
}

/** Возвращает текст партии строки АИ. */
export function formatInventoryLot(content: StockActInvContent): string {
    if (!isStockFullInventoryContentLotBased(content)) {
        return "Без партии";
    }

    return formatLotText(content.Lot);
}

/**
 * Возвращает признак инвентаризации строки АИ (`IsInventoried`). \
 * Backend выставляет флаг автоматически после `contents.updateFactQties`.
 * @param content строка состава АИ
 */
export function isStockFullInventoryContentInventoried(content: Pick<StockActInvContent, "IsInventoried">): boolean {
    return content.IsInventoried === true;
}

/** Формирует label поля фактического количества по ячейке. */
export function formatInventoryCellQtyLabel(remainder: StorePlaceRemainder, content: StockActInvContent): string {
    const cellText = remainder.StorePlace?.Num ?? `Ячейка ${remainder.SpCode}`;
    const measureText = formatMeasureValueText("1", content.Measure).replace("1", "").trim();

    return measureText === "" ? `Кол-во факт в ячейке ${cellText}` : `Кол-во факт в ячейке ${cellText} ${measureText}`;
}
